import React, { type FC, type PropsWithChildren } from 'react';

import { type HighlightProps } from '@component/Highlight/types';

import { Styled } from './styled';

export const Highlight: FC<PropsWithChildren<HighlightProps>> = ({ children, color, ...props }) => {
  return <Styled.Highlight {...props} $color={color}>{children}</Styled.Highlight>;
};
